
import { Component, Mixins, ActionButtonConfig, FormModalMixins } from "@/lib";
import Sender from "@/store/modules/system/sender/entity";
import { Row } from "view-design";
@Component
export default class EditSender extends Mixins(FormModalMixins) {
  model = new Sender();
  created() {
    Object.assign(this.config, { modelTitleL: "Action.Edit", labelWidth: 120, okAction: "system/sender/update" });
  }
  get record() {
    return this.$store.state.system.sender.editSender;
  }
  validateFeild(field) {
    (this.$refs["form-modal"] as any).validateField(field);
  }
  close() {
    this.config.isShow = false;
    this.model = new Sender();
  }
}
